import { ActivatedRouteSnapshot, Route } from '@angular/router';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./news/news-list/news-list.component').then((m) => m.NewsListComponent),
  },
  {
    path: 'news/:id',
    loadComponent: () =>
      import('./news/news-detail/news-detail.component').then((m) => m.NewsDetailComponent),
    data: {
      breadcrumb: (route: ActivatedRouteSnapshot) => {
        return route.params['id'];
      },
    },
  },
  {
    path: ':pageUrl',
    loadComponent: () => import('./page/page.component').then((m) => m.PageComponent),
    data: {
      breadcrumb: (route: ActivatedRouteSnapshot) => {
        return route.params['pageUrl'];
      },
    },
  },
];
